import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { log, NtapGlobalConstants, UIComponents, Util } from '@ntap/core';
import { combineLatest, Subscription } from 'rxjs';

import { ParentItemProviderService } from '@app/shared';

@Component({
  selector: 'app-jedinica-gradiva-predaja-lista',
  templateUrl: './jedinica-gradiva-predaja-lista.component.html',
  providers: [ParentItemProviderService]
})
export class JedinicaGradivaPredajaListaComponent implements OnInit, OnDestroy {
  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  parentItem: any;

  routeChangeSubscription: Subscription;

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService
  ) {}

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  ngOnDestroy(): void {
    this.unsubscribeFromRouteChange();
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.routeChangeSubscription = combineLatest([
      this.route.paramMap,
      this.parentItemProvider.parentItem$
    ]).subscribe(([, parentItem]: [params: any, parentItem: any]) => {
      log('param change');
      this.parentItem = parentItem;
      this.changeView('lista_jedinica_gradiva_za_predaju', parentItem);
    });
  }

  unsubscribeFromRouteChange(): any {
    log('Unsubsubscribe from route params');
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      [Util.getFullAttrName('earhiv.predaja_gradiva', 'id')]:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ]
    };
    this.currentListViewStateFilter = {};
  }
}
